import {
  AvgLabelCostByCarrierResponseSchema,
  OMSMetricsRequestSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAvgLabelCostByCarrier = {
  name: "getAvgLabelCostByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: AvgLabelCostByCarrierResponseSchema,
};
